module.exports = __webpack_public_path__ + "img/f7-2.17e4608f.png";